// extracted by mini-css-extract-plugin
export var sliderRange = "_q1-2";
export var sliderRoot = "_q1-0";
export var sliderThumb = "_q1-3";
export var sliderTrack = "_q1-1";